import { AccordionItemType } from '@treatwell/ui';
import { CmsText } from 'js/components/CmsText/CmsText';
import { substituteWithDictionary } from 'js/helpers/i18n';
import { formatPrice } from 'js/helpers/price/priceUtilities';
import { FAQ } from 'js/model/cms/cms-treatwell-rewards';
import {
  ChannelLoyalty,
  ORDER_CHALLENGE,
} from 'js/model/rainbow/content/ChannelOutput';
import cloneDeep from 'lodash.clonedeep';
import React from 'react';
import { getAchievements } from './getAchievements';

export const generateFAQsContent = ({
  channel,
  cmsFAQs,
}: {
  channel: ChannelLoyalty;
  cmsFAQs: FAQ[];
}): AccordionItemType[] => {
  const {
    lowestMilestone,
    highestMilestone,
    lowestAchievementValue,
    highestAchievementValue,
  } = getAchievements({
    achievements: channel.loyalty.achievements,
    channel,
  });
  const { earnRateNumerator, earnRateDenominator } =
    channel.loyalty.challenges[ORDER_CHALLENGE];
  const earnRate = formatPrice(earnRateNumerator, channel);

  /**
   *  Copy FAQs CMS strings so we can mutate them
   * Ex:
   *    You'll earn {points} points for every {earnRate} spent when paying in advance
   * */
  const faqsContent: FAQ[] = cloneDeep(cmsFAQs);

  faqsContent[0].content = substituteWithDictionary(cmsFAQs[0].content, {
    count: String(channel.loyalty.achievements.length),
    lowestMilestone: String(lowestMilestone),
    highestMilestone: String(highestMilestone),
    lowestAchievementValue,
    highestAchievementValue,
  });

  faqsContent[1].content = substituteWithDictionary(cmsFAQs[1].content, {
    points: String(earnRateDenominator),
    // will be changed to get the value from /channel when MAT-4077 is complete
    pointsPAV: '1',
    earnRate,
    earnRatePAV: earnRate,
  });

  faqsContent[2].content = substituteWithDictionary(cmsFAQs[2].content, {
    points: String(earnRateDenominator),
    // will be changed to get the value from /channel when MAT-4077 is complete
    pointsPAV: '1',
    earnRate,
    earnRatePAV: earnRate,
  });

  faqsContent[5].content = substituteWithDictionary(cmsFAQs[5].content, {
    lowestAchievementValue,
    highestAchievementValue,
  });

  const faqs = faqsContent.map((faq, index) => {
    const content = <CmsText text={faq.content} isParagraph />;

    return { title: faq.title, content, id: String(index) };
  });

  return faqs;
};
